import React from 'react';
import { Card } from '../Card'; // Assumendo l'esistenza di questo componente
import { School } from '../../model/registration/SchoolSelection';

interface SchoolAddressSelectionProps {
  options: School[];
  onSchoolAddressSelection: () => void;
  setSelectedSchoolAddress: (selectedAddress: string) => void;
}

const SchoolAddressSelection: React.FC<SchoolAddressSelectionProps> = ({
  options,
  onSchoolAddressSelection,
  setSelectedSchoolAddress,
}) => {
  function onClick(selectedAddress: string) {
    setSelectedSchoolAddress(selectedAddress);
    onSchoolAddressSelection();
  }

  return (
    <div className="w-full bg-white rounded-lg sm:rounded-xl px-6 py-3 sm:p-6 lg:p-8 shadow-lg">
      <div className="text-center mb-4 sm:mb-6 lg:mb-8">
        <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-black mb-1 sm:mb-2">
          Quale indirizzo frequenta?
        </h2>
        <p className="text-xs sm:text-sm lg:text-base text-gray-600 px-2">Seleziona l'indirizzo di studio specifico</p>
      </div>

      <div className="flex flex-col items-center gap-3 sm:gap-4 lg:gap-6 max-w-lg mx-auto">
        {options.map((option, index) => (
          <Card key={index} title={option.name} onClick={() => onClick(option.name)} />
        ))}
      </div>
    </div>
  );
};

export default SchoolAddressSelection;
